var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09998 11V12.4",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76672 14.6665H11.4334V13.9998C11.4334 13.2665 10.8334 12.6665 10.1001 12.6665H6.10006C5.36672 12.6665 4.76672 13.2665 4.76672 13.9998V14.6665V14.6665Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09998 14.6665H12.1",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 10.6668C5.42004 10.6668 3.33337 8.58016 3.33337 6.00016V4.00016C3.33337 2.52683 4.52671 1.3335 6.00004 1.3335H10C11.4734 1.3335 12.6667 2.52683 12.6667 4.00016V6.00016C12.6667 8.58016 10.58 10.6668 8.00004 10.6668Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64665 7.76657C3.14665 7.60657 2.70665 7.31324 2.35999 6.96657C1.75999 6.2999 1.35999 5.4999 1.35999 4.56657C1.35999 3.63324 2.09332 2.8999 3.02665 2.8999H3.45999C3.32665 3.20657 3.25999 3.54657 3.25999 3.8999V5.8999C3.25999 6.56657 3.39999 7.19324 3.64665 7.76657Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3534 7.76657C12.8534 7.60657 13.2934 7.31324 13.6401 6.96657C14.2401 6.2999 14.6401 5.4999 14.6401 4.56657C14.6401 3.63324 13.9067 2.8999 12.9734 2.8999H12.5401C12.6734 3.20657 12.7401 3.54657 12.7401 3.8999V5.8999C12.7401 6.56657 12.6001 7.19324 12.3534 7.76657Z",
    stroke: "#68717B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCup);
export default __webpack_public_path__ + "static/media/cup.b4167e4f317c657189ebc8ca3ac60ef8.svg";
export { ForwardRef as ReactComponent };